<template>
  <div class="customer-portal-app w-full bg-white pt-20 xl:pt-3 pb-10 !px-7 md:!px-12 xl:!px-24 flex flex-col items-start print:pt-5">
    <div
      v-if="isUserLoggedIn && !state.isShareQuotePage"
      class="customer-portal-breadcrumbs w-full">
      <BreadcrumbsComponents :startPageName="'Customer Portal'" />
    </div>
    <CPMainNavigation v-if="isUserLoggedIn && !state.isShareQuotePage" />
    <keep-alive>
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </keep-alive>
  </div>
</template>

<script setup lang="ts">
import { onMounted, watch, reactive } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { CPRouterPaths } from '@/apps/website/customer-portal/router';
import BreadcrumbsComponents from '@/components/website/global/BreadcrumbsComponents.vue';
import CPMainNavigation from '@/components/website/customer-portal/navigation/CPMainNavigation.vue';
import VariablesHelper from '@/helpers/global/variables.helper';
import useUserInfoStore from '@/store/userInfo';

const router = useRouter();
const route = useRoute();

const userInfoStore = useUserInfoStore();

const isUserLoggedIn = IS_LOGGED_IN || false;

const state = reactive({
  isShareQuotePage: false,
});

const checkIfShareQuotePage = () => {
  state.isShareQuotePage = window.location.pathname.includes('/quotes/share/');
};

const redirectToAuthPage = () => {
  if (!isUserLoggedIn && route.path !== CPRouterPaths.authPage && !state.isShareQuotePage) {
    localStorage.setItem(VariablesHelper.AUTH_REDIRECT_URL_LS_KEY, window.location.href);
    router.push(CPRouterPaths.authPage);
  }
};

onMounted(() => {
  if (isUserLoggedIn && userInfoStore.userInfo === undefined) {
    userInfoStore.fetchUserInfo();
  }

  checkIfShareQuotePage();
  redirectToAuthPage();
});

watch(
  () => route.path,
  () => {
    checkIfShareQuotePage();
    redirectToAuthPage();
  }
);
</script>
